import {
  AddressDto,
  AttachmentTypeDto,
  CarStatusDto,
  ContactInfoTypeDto,
  ContactStatusDto,
  CustomerFlagDto,
  CustomerStatusDto,
  CustomerTypeDto,
  DictionaryTypeDto,
  DishCategoryDto,
  DishUnitMeasurementDto,
  ProcessOfferStatusDto,
  ProcessStatusDto,
  ResourceTypeDto,
  SupplierStatusDto,
  TaskStatusDto,
  UnitMeasurementDto,
  UpdateEmailContentTypeDto,
  UserRoleDto,
} from '@/api/generated';

export type Address = Record<keyof AddressDto, string>;
export type CarStatusOptionsTranslation = Record<CarStatusDto, string>;
export type ContactStatusOptionsTranslation = Record<ContactStatusDto, string>;
export type CustomerStatusOptionsTranslation = Record<CustomerStatusDto, string>;
export type CustomerTypeOptionsTranslation = Record<CustomerTypeDto, string>;
export type DictionariesTranslation = {
  booleanOptions: BooleanOptionsTranslation;
  carStatusOptions: CarStatusOptionsTranslation;
  contactInfoTypeOptions: ContactInfoTypeOptionsTranslation;
  contactStatusOptions: ContactStatusOptionsTranslation;
  customerStatusOptions: CustomerStatusOptionsTranslation;
  customerTypeOptions: CustomerTypeOptionsTranslation;
  dictionaryTypeOptions: DictionaryTypeOptionsTranslation;
  emailAttachmentTypeOptions: EmailAttachmentTypeOptionsTranslation;
  emailContentTypeOptions: UpdateEmailContentTypeOptionsTranslation;
  flagOptions: FlagOptionsTranslation;
  processOfferStatusOptions: ProcessOfferStatusOptionsTranslation;
  processStatusOptions: ProcessStatusTranslation;
  resourceTypeOptions: ResourceTypeTranslation;
  supplierStatusOptions: SupplierStatusOptionsTranslation;
  taskStatusOptions: TaskStatusOptionsTranslation;
  userRolesOptions: UserRolesOptionsTranslation;
};
export type DictionaryTypeOptionsTranslation = Record<DictionaryTypeDto, string>;
export type DishCategoryOptionsTranslation = Record<DishCategoryDto, string>;
export type DishUnitOptionsTranslation = Record<DishUnitMeasurementDto, string>;
export type EmailAttachmentTypeOptionsTranslation = Record<AttachmentTypeDto, string>;
export type FlagOptionsTranslation = Record<CustomerFlagDto, string>;
export type ProcessOfferStatusOptionsTranslation = Record<ProcessOfferStatusDto, string>;
export type ProcessStatusTranslation = Record<ProcessStatusDto, string>;
export type SupplierStatusOptionsTranslation = Record<SupplierStatusDto, string>;
export type TaskStatusOptionsTranslation = Record<TaskStatusDto, string>;
export type UnitOptionsTranslation = Record<UnitMeasurementDto, string>;
export type UpdateEmailContentTypeOptionsTranslation = Record<UpdateEmailContentTypeDto, string>;

export const taskStatusOptionsTranslation: TaskStatusOptionsTranslation = {
  [TaskStatusDto.Canceled]: 'Anulowane',
  [TaskStatusDto.Done]: 'Zakończone',
  [TaskStatusDto.DoneNotConfirmed]: 'Zakończone (niepotwierdzone)',
  [TaskStatusDto.InProgress]: 'W trakcie',
  [TaskStatusDto.New]: 'Nowe',
  [TaskStatusDto.Postponed]: 'Odłożone',
  [TaskStatusDto.Rejected]: 'Odrzucone',
};

export type UserRolesOptionsTranslation = Record<UserRoleDto, string>;

type BooleanOptionsTranslation = {
  false: string;
  true: string;
};

export const customerTypeOptionsTranslation: CustomerTypeOptionsTranslation = {
  [CustomerTypeDto.Business]: 'Biznesowy',
  [CustomerTypeDto.ForeignBusiness]: 'Zagraniczny',
  [CustomerTypeDto.Individual]: 'Indywidualny',
};

export const carStatusOptionsTranslation: CarStatusOptionsTranslation = {
  [CarStatusDto.Active]: 'W użyciu',
  [CarStatusDto.Inactive]: 'Wyłączony z użycia',
};

export type ContactInfoTypeOptionsTranslation = Record<ContactInfoTypeDto, string>;

export const contactInfoTypeOptionsTranslation: ContactInfoTypeOptionsTranslation = {
  [ContactInfoTypeDto.Email]: 'Adres email',
  [ContactInfoTypeDto.Phone]: 'Numer telefonu',
};

export const emailContentTypeOptions: UpdateEmailContentTypeOptionsTranslation = {
  [UpdateEmailContentTypeDto.Boxes]: '!! AKTYWNA BOXY',
  [UpdateEmailContentTypeDto.CakeInstallationAgencies]: '11. Cake installation – agencje',
  [UpdateEmailContentTypeDto.CakeInstallationCompanies]: '10. Cake installation – korporacje',
  [UpdateEmailContentTypeDto.Christmas2026]: '19. Święta 2026',
  [UpdateEmailContentTypeDto.ChristmasOffer]: '17. Oferta świąteczna',
  [UpdateEmailContentTypeDto.Custom]: '00. Własne',
  [UpdateEmailContentTypeDto.DecisionQuestionRequest]: '04. Pytanie co z decyzją',
  [UpdateEmailContentTypeDto.Easter2026]: '18. Wielkanoc 2026',
  [UpdateEmailContentTypeDto.FatThursday]: '15. Tłusty czwartek',
  [UpdateEmailContentTypeDto.ForumEventCompanies]: '14. Podziękowania forum branży eventowej',
  [UpdateEmailContentTypeDto.General]: '07. AKTYWNA Oferta ogólna',
  [UpdateEmailContentTypeDto.GrazingTable]: '08. AKTYWNA Grazing Table',
  [UpdateEmailContentTypeDto.NewSeason2026]: '01. AKTYWNA Nowy sezon Nowe Pomysły',
  [UpdateEmailContentTypeDto.OpenDayFoksal]: '16. Dzień otwarty - Pałac na Foksal',
  [UpdateEmailContentTypeDto.OpinionRequest]: '06. Prośba o opinię',
  [UpdateEmailContentTypeDto.PostEventFollowUp]: '05. Podziękowanie po event-cie',
  [UpdateEmailContentTypeDto.ResponseAsSoonAsPossible]: '01. Zapytanie – szybka odpowiedź',
  [UpdateEmailContentTypeDto.ResponseAsSoonAsPossibleWithRequestVerification]:
    '02. Opcjonalnie - weryfikacja potrzeb',
  [UpdateEmailContentTypeDto.SendingOffer]: '03. Wysyłka oferty',
  [UpdateEmailContentTypeDto.SixFloorTheatre]: '12. Oferta Teatru 6. Piętro',
  [UpdateEmailContentTypeDto.SixFloorTheatreOpenDay]: '13. Dzień otwarty Teatru 6. Piętro',
};

export const emailAttachmentsTypeOptions: EmailAttachmentTypeOptionsTranslation = {
  [AttachmentTypeDto.CakeInstallation]: 'Cake Installation',
  [AttachmentTypeDto.Christmas2026]: 'Boże Narodzenie 2026',
  [AttachmentTypeDto.Easter2026Album]: 'Wielkanoc 2026 - Album',
  [AttachmentTypeDto.Easter2026Offer]: 'Wielkanoc 2026 - Oferta',
  [AttachmentTypeDto.GeneralOffer]: 'Oferta ogólna',
  [AttachmentTypeDto.GrazingTable]: 'Grazing Table',
};

export const userRolesOptionsTranslation: UserRolesOptionsTranslation = {
  [UserRoleDto.Accounting]: 'Księgowość',
  [UserRoleDto.Admin]: 'Admin',
  [UserRoleDto.Confectionery]: 'Cukiernia',
  [UserRoleDto.DecoratorsStudio]: 'Dekoratornia',
  [UserRoleDto.DevelopmentDirector]: 'Dyrektor ds. rozwoju',
  [UserRoleDto.EquipmentDepartment]: 'Dział sprzętu',
  [UserRoleDto.GoodsDepartment]: 'Magazyn',
  [UserRoleDto.ImplementationDepartment]: 'Dział realizacji',
  [UserRoleDto.Kitchen]: 'Kuchnia',
  [UserRoleDto.LogisticsDepartment]: 'Dział logistyki',
  [UserRoleDto.ManagingDirector]: 'Dyrektor zarządzający',
  [UserRoleDto.MarketingDepartment]: 'Dział marketingu',
  [UserRoleDto.Owner]: 'Właściciel',
  [UserRoleDto.SalesDepartment]: 'Dział sprzedaży',
  [UserRoleDto.SalesManagerDirector]: 'Dyrektor ds. sprzedaży',
};

export const flagOptionsTranslation: FlagOptionsTranslation = {
  [CustomerFlagDto.Green]: 'Zaakceptowany do realizacji',
  [CustomerFlagDto.Red]: 'Odrzuć zamówienie',
  [CustomerFlagDto.Yellow]: 'Wymaga weryfikacji',
};

export const customerStatusOptionsTranslation: CustomerStatusOptionsTranslation = {
  [CustomerStatusDto.Active]: 'Aktywny',
  [CustomerStatusDto.Inactive]: 'Nieaktywny',
};

const booleanOptionsTranslations: BooleanOptionsTranslation = {
  false: 'Nie',
  true: 'Tak',
};

export const addressTranslation: Address = {
  community: 'Gmina',
  county: 'Powiat',
  flatNo: 'Numer mieszkania',
  houseNo: 'Numer domu',
  locality: 'Miejscowość',
  postCode: 'Kod pocztowy',
  province: 'Województwo',
  street: 'Ulica',
};

export const processStatusOptionsTranslation: ProcessStatusTranslation = {
  [ProcessStatusDto.Canceled]: 'Anulowany',
  [ProcessStatusDto.Created]: 'Nowy',
  [ProcessStatusDto.Finished]: 'Zakończony',
  [ProcessStatusDto.InProgress]: 'W trakcie',
};

export const dictionaryTypeOptionsTranslation: DictionaryTypeOptionsTranslation = {
  [DictionaryTypeDto.CarDeadlineType]: 'Terminy aut',
  [DictionaryTypeDto.CarType]: 'Auta',
  [DictionaryTypeDto.DietaryPreference]: 'Preferencja żywieniowa',
  [DictionaryTypeDto.DishDepartment]: 'Dział',
  [DictionaryTypeDto.DishType]: 'Rodzaj dania',
  [DictionaryTypeDto.EmergencyContactCategoryType]: 'Numery awaryjne',
  [DictionaryTypeDto.EventType]: 'Typ wydarzenia',
  [DictionaryTypeDto.MenuType]: 'Rodzaj Menu',
  [DictionaryTypeDto.PackageOfferItem]: 'Element oferty',
  [DictionaryTypeDto.PredefinedOffer]: 'Oferta predefiniowana',
  [DictionaryTypeDto.SupplierType]: 'Rodzaj dostawcy',
  [DictionaryTypeDto.Tag]: 'Tagi',
};

export const dishUnitTypesOptionsTranslation: DishUnitOptionsTranslation = {
  [DishUnitMeasurementDto.Gram]: 'g',
  [DishUnitMeasurementDto.Milliliter]: 'ml',
  [DishUnitMeasurementDto.Unit]: 'szt',
};

export const dishCategoryOptionsTranslation: DishCategoryOptionsTranslation = {
  [DishCategoryDto.Dessert]: 'Deser',
  [DishCategoryDto.Dish]: 'Potrawa',
  [DishCategoryDto.Drink]: 'Napój',
};

export const unitMeasurementOptionsTranslation: UnitOptionsTranslation = {
  [UnitMeasurementDto.Gram]: 'gramy',
  [UnitMeasurementDto.Hour]: 'godziny',
  [UnitMeasurementDto.Milliliter]: 'ml',
  [UnitMeasurementDto.People]: 'osoby',
  [UnitMeasurementDto.Unit]: 'sztuki',
};

export const supplierStatusOptionsTranslation: SupplierStatusOptionsTranslation = {
  [SupplierStatusDto.Active]: 'Aktywny',
  [SupplierStatusDto.Inactive]: 'Nieaktywny',
};

export const processOfferStatusOptionsTranslation: ProcessOfferStatusOptionsTranslation = {
  [ProcessOfferStatusDto.Canceled]: 'Anulowana',
  [ProcessOfferStatusDto.ConfirmedForRealization]: 'Zaakceptowana',
  [ProcessOfferStatusDto.Draft]: 'Szkic',
  [ProcessOfferStatusDto.Executed]: 'Zrealizowana',
  [ProcessOfferStatusDto.Finished]: 'Zakończona',
  [ProcessOfferStatusDto.InRealization]: 'W realizacji',
  [ProcessOfferStatusDto.OfferAccepted]: 'Sprzedana',
  [ProcessOfferStatusDto.Offering]: 'W trakcie ofertowania',
  [ProcessOfferStatusDto.Payed]: 'Opłacona',
};
export type ResourceTypeTranslation = Record<ResourceTypeDto, string>;

export const resourceTypeTranslation: ResourceTypeTranslation = {
  [ResourceTypeDto.Car]: 'Auto',
  [ResourceTypeDto.CarLogEntry]: 'Wpis dziennika auta',
  [ResourceTypeDto.Chat]: 'Czat',
  [ResourceTypeDto.Contact]: 'Kontakt',
  [ResourceTypeDto.Customer]: 'Klient',
  [ResourceTypeDto.Email]: 'Email',
  [ResourceTypeDto.IncidentTicket]: 'Incydent',
  [ResourceTypeDto.Process]: 'Proces',
  [ResourceTypeDto.ProcessOffer]: 'Oferta',
  [ResourceTypeDto.SettlementPayment]: 'Płatność',
  [ResourceTypeDto.Supplier]: 'Dostawca',
  [ResourceTypeDto.Task]: 'Zadanie',
  [ResourceTypeDto.User]: 'Użytkownik',
};

export const contactStatusOptionsTranslation: ContactStatusOptionsTranslation = {
  [ContactStatusDto.Active]: 'Aktywny',
  [ContactStatusDto.Inactive]: 'Nieaktywny',
};

export const dictionariesTranslation: DictionariesTranslation = {
  booleanOptions: booleanOptionsTranslations,
  carStatusOptions: carStatusOptionsTranslation,
  contactInfoTypeOptions: contactInfoTypeOptionsTranslation,
  contactStatusOptions: contactStatusOptionsTranslation,
  customerStatusOptions: customerStatusOptionsTranslation,
  customerTypeOptions: customerTypeOptionsTranslation,
  dictionaryTypeOptions: dictionaryTypeOptionsTranslation,
  emailAttachmentTypeOptions: emailAttachmentsTypeOptions,
  emailContentTypeOptions: emailContentTypeOptions,
  flagOptions: flagOptionsTranslation,
  processOfferStatusOptions: processOfferStatusOptionsTranslation,
  processStatusOptions: processStatusOptionsTranslation,
  resourceTypeOptions: resourceTypeTranslation,
  supplierStatusOptions: supplierStatusOptionsTranslation,
  taskStatusOptions: taskStatusOptionsTranslation,
  userRolesOptions: userRolesOptionsTranslation,
};
